export default __webpack_public_path__ + "static/media/tete91.1e28c06f.png";